var ChartFlowDuration = /** @class */ (function () {
    function ChartFlowDuration(config, svgLayers) {
        this.config = config;
        this.svgLayers = svgLayers;
        this.start = {};
    }
    ChartFlowDuration.prototype.draw = function (data) {
        var self = this;
        this.durationGroup = this.svgLayers.data.selectAll('.duration_group')
            .data(data);
        this.durationGroup.exit().remove();
        this.durationGroupEnter = this.durationGroup.enter()
            .append("g")
            .attr("class", "duration_group");
        this.durationText = this.durationGroupEnter.merge(this.durationGroup)
            .append("text")
            .html(function (d, i) {
            if (i > 0 && i < data.length - 1) {
                return d.duration + ' dagen';
            }
        })
            .style("font-size", ".825rem")
            .style("text-anchor", "middle");
        this.durationLabel = this.svgLayers.data
            .append('text')
            .attr("class", "small-label")
            .text('Gem. tijd per stap:');
    };
    ChartFlowDuration.prototype.redraw = function (data, dimensions, rScale, xScale) {
        var self = this;
        this.durationGroupEnter.merge(this.durationGroup)
            .attr("transform", function (d, i) {
            var halfway = data[i].cumulativeDuration + (data[i].duration / 2);
            return "translate(" + xScale(halfway) + ", " + (dimensions.height - 85) + ")";
        });
        this.durationLabel
            .attr("transform", function (d, i) {
            return "translate(" + xScale(0) + ", " + (dimensions.height - 85) + ")";
        });
    };
    ChartFlowDuration.prototype.forceDirect = function (xScale, rScale, data) {
        var self = this;
        var triangleSize = 40;
    };
    return ChartFlowDuration;
}());
export { ChartFlowDuration };
